import amplitudeService from '@features/analytics/amplitudeService';

export function EnterpriseLink() {
  const handleClick = () => {
    amplitudeService.logEvent('[Paywall] enterprise link click');
    window.open('https://www.banani.co/contact-sales', '_blank');
  };

  return (
    <p className='text-center text-sm text-black/50'>
      Looking for enterprise option?{' '}
      <button onClick={handleClick} className='font-semibold text-black/50'>
        Contact us
      </button>
    </p>
  );
}
